import React from 'react';
import SelectableCard from "../../../../../../../components-new/general/SelectableCard";
import Translate, {t} from "../../../../../../../components/Translate";
import colors from "../../../../../../../utils/Colors";
import ForumIcon from "../../../../../../../assets/icons/ForumIcon";
import EmployeesIcon from "../../../../../../../assets/icons/nav/EmployeesIcon";
import CircleAlertIcon from "../../../../../../../assets/icons/CircleAlertIcon";
import Input from "../../../../../../../components-new/form/Input";
import Field from "../../../../../../../components-new/form/Field";
import graphConfig from "../../../config";

const cardStyle = {width: '100%', minHeight: '64px'};

/*
 * What kind of node this is.
 *
 * It sits at the foot of the editor rather than the top, and that is on purpose:
 * almost every node is an ordinary one, and a question you answer once per
 * hundred nodes should not be the first thing in the way of the ninety-nine.
 * Changing it hides most of the panel above, which is why it reads as a decision
 * about the node rather than another setting on it.
 */
const NodeTypePicker = ({
                            nodeType,
                            setNodeType,
                            outOfHoursText,
                            setOutOfHoursText,
                            hasWorkingHours,
                            hasChildren,
                            user
                        }) => {

    const types = [
        {
            value: graphConfig.nodeTypes.message,
            icon: ForumIcon,
            label: 'nodeTypeMessage',
            note: 'nodeTypeMessageNote',
            color: colors.blueDark,
        },
        {
            value: graphConfig.nodeTypes.operatorTransfer,
            icon: EmployeesIcon,
            label: 'nodeTypeOperatorTransfer',
            note: 'nodeTypeOperatorTransferNote',
            color: colors.blueAccent,
        },
    ];

    const isTransfer = nodeType === graphConfig.nodeTypes.operatorTransfer;

    /*
     * Refused while anything hangs off this node.
     *
     * The change would not fail - it would succeed and quietly strand whatever
     * the buttons lead to, because a node that hands the chat over sends no
     * buttons at all. The card is shown rather than hidden, with the reason
     * underneath: a choice that disappears is a choice nobody can ask about.
     *
     * Only ever blocks the way in. A node already of this type has no children
     * to lose, and must always be able to become an ordinary one again.
     */
    const blockedType = hasChildren && !isTransfer
        ? graphConfig.nodeTypes.operatorTransfer
        : null;

    return (
        <div className="control-section node-type-picker">
            {types.map((type) => {
                const Icon = type.icon;
                const isSelected = nodeType === type.value;
                const isBlocked = blockedType === type.value;

                return (
                    <SelectableCard
                        key={type.value}
                        isSelected={isSelected}
                        disabled={isBlocked}
                        onSelect={() => setNodeType(type.value)}
                        style={cardStyle}
                    >
                        <div className="node-type-picker__card">
                            {/*
                              * 26 rather than 20. These two marks are what the
                              * card is choosing between, and one of them is a
                              * filled drawing of several small figures that
                              * turns to mush below this size - it was reading as
                              * a smudge next to the plain outlined bubble.
                              *
                              * Boxed, so a filled icon and an outlined one take
                              * the same room and the two titles line up.
                              */}
                            <span className="node-type-picker__icon">
                                <Icon width={26} height={26}
                                      style={{color: isSelected ? type.color : colors.silverBlue}}
                                      stroke="currentColor"/>
                            </span>
                            <div className="node-type-picker__text">
                                <span className="node-type-picker__label"
                                      style={{color: isSelected ? type.color : colors.silverBlueDark}}>
                                    <Translate text={type.label}/>
                                </span>
                                <span className="node-type-picker__note">
                                    <Translate text={isBlocked ? 'nodeTypeBlockedByChildren' : type.note}/>
                                </span>
                            </div>
                        </div>
                    </SelectableCard>
                );
            })}

            {isTransfer && (
                <div className="node-editor-auto-transfer">
                    <div className="node-editor-auto-transfer__note">
                        <CircleAlertIcon height={16} width={16} style={{flexShrink: 0, transform: 'translateY(2px)'}}/>
                        <Translate text="autoTransferToOperatorExplanation"/>
                    </div>

                    {hasWorkingHours && (
                        <Field
                            label="autoTransferOutOfHoursText"
                            help="autoTransferOutOfHoursTextHelp"
                            htmlFor="node-out-of-hours-text"
                        >
                            <Input
                                id="node-out-of-hours-text"
                                isTextarea
                                resize="vertical"
                                style={{width: '100%', minHeight: '90px'}}
                                maxLength={4000}
                                placeholder={t({text: 'autoTransferOutOfHoursTextPlaceholder', user})}
                                value={outOfHoursText}
                                onChange={(e) => setOutOfHoursText(e.target.value)}
                            />
                        </Field>
                    )}
                </div>
            )}
        </div>
    );
};

export default NodeTypePicker;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/graph/containers/NodeEditor/partials/NodeTypePicker.jsx